import { faLongArrowAltLeft, faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

import styles from "./pagination.module.scss";

export type TPaginationProps = {
    currentPagePosition: number,
    maximumPagePosition: number,
    goToNextPage?: () => void,
    goToPreviousPage?: () => void
}

export const Pagination: FC<TPaginationProps> = ({ currentPagePosition, maximumPagePosition, goToNextPage, goToPreviousPage } : TPaginationProps) => {
    return (
        <div className={styles.paginationElement}>
            <span className={styles.paginationArrow} onClick={goToPreviousPage}><FontAwesomeIcon icon={faLongArrowAltLeft} /> Prev</span>
            <span>{currentPagePosition}</span>
            <span>of</span>
            <span>{maximumPagePosition}</span>
            <span className={styles.paginationArrow} onClick={goToNextPage} >Next <FontAwesomeIcon icon={faLongArrowAltRight} /></span>
        </div>
    );
}